import {
  SCRATCHED_TICKETS_REQUEST,
  SCRATCHED_TICKETS_SUCCESS,
  SCRATCHED_TICKETS_FAILURE
} from 'Store/constants';
  
    
const initialState = {
  data: null,
  isLoading: null,
  error: null
};
    
export default (state = initialState, action) => {
  switch (action.type) {
    case SCRATCHED_TICKETS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SCRATCHED_TICKETS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case SCRATCHED_TICKETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
